import httpRequest from 'httpRequest'
import { VendorContract } from 'models'

const VENDOR_PREFIX = '/location/vendors'

const vendorService = {
    getVendors: () => {
        return httpRequest.get<VendorContract[]>(VENDOR_PREFIX)
    },
    getVendorByID: (id: string) => {
        return httpRequest.get<VendorContract>(`${VENDOR_PREFIX}/${id}`)
    },
    createVendor: (payload: VendorContract) => {
        return httpRequest.post(`${VENDOR_PREFIX}`, payload)
    },
    updateVendor: (id: string, payload: VendorContract) => {
        return httpRequest.put(`${VENDOR_PREFIX}/${id}`, payload)
    },
    deleteVendor: (vendorIDs: string[]) => {
        return httpRequest.delete(`${VENDOR_PREFIX}`, { params: { vendorIDs } })
    },
    activateVendor: (vendorID: string) => {
        return httpRequest.put<boolean>(`${VENDOR_PREFIX}/${vendorID}/activate`)
    },
    deactivateVendor: (vendorID: string) => {
        return httpRequest.put<boolean>(
            `${VENDOR_PREFIX}/${vendorID}/deactivate`,
        )
    },
}

export default vendorService
